angular.module("dx.webapp.session", [
	"ngCookies",

	"dx.webapp.kayako",
	"dx.webapp.region",
	"dx.webapp.user",
	"digiexam.node",
	"digiexam.services",

	"ngRaven",
]);
